/**
 * Pull the backend validation message out of an axios error, in priority order.
 *
 * express-validator returns `{ errors: [{ msg }] }` on a 400, which is the specific
 * message worth showing; `{ error }` is the generic route-level shape. Falling
 * straight to a generic string hides the only useful part of a validation failure.
 */
export function extractApiError(err) {
  const data = err?.response?.data;
  return (
    data?.errors?.[0]?.msg
    || data?.error
    || 'Failed to create asset'
  );
}
